import React from 'react';
import { EditMode, LayoutServicePageState, RenderingType } from '@sitecore-jss/sitecore-jss/layout';
import { useSitecoreContext } from '../enhancers/withSitecoreContext';
import { getJssPagesClientData } from '@sitecore-jss/sitecore-jss/editing';
import { getDesignLibraryScriptLink } from '@sitecore-jss/sitecore-jss/editing';
/**
 * - Renders client scripts and data for editing/preview mode for Pages
 * - Renders script required for the Design Library (when RenderingType is `component`).
 * This script is only rendered when EditMode is Metadata or RenderingType is `component`, otherwise it renders nothing.
 * @returns A JSX element containing the editing scripts or an empty fragment if not in editing/preview mode.
 */
export const EditingScripts = () => {
    var _a;
    const { sitecoreContext: { pageState, editMode, clientData, clientScripts, renderingType }, api, } = useSitecoreContext();
    // Don't render anything if not in editing/preview mode and rendering type is not component
    if (renderingType !== RenderingType.Component &&
        (pageState === LayoutServicePageState.Normal || pageState === LayoutServicePageState.Preview)) {
        return React.createElement(React.Fragment, null);
    }
    // In case of RenderingType.Component - render only the script for Design Libnrary
    if (renderingType === RenderingType.Component) {
        // Add cache buster to the script URL
        const scriptUrl = `${getDesignLibraryScriptLink((_a = api === null || api === void 0 ? void 0 : api.edge) === null || _a === void 0 ? void 0 : _a.edgeUrl)}?cb=${Date.now()}`;
        return (React.createElement(React.Fragment, null,
            React.createElement("script", { src: scriptUrl, suppressHydrationWarning: true })));
    }
    if (editMode === EditMode.Metadata) {
        const jssClientData = Object.assign(Object.assign({}, clientData), getJssPagesClientData());
        return (React.createElement(React.Fragment, null, clientScripts === null || clientScripts === void 0 ? void 0 :
            clientScripts.map((src, index) => (React.createElement("script", { src: src, key: index }))),
            Object.keys(jssClientData).map((id) => (React.createElement("script", { key: id, id: id, type: "application/json", dangerouslySetInnerHTML: { __html: JSON.stringify(jssClientData[id]) } })))));
    }
    return React.createElement(React.Fragment, null);
};
